export default {
  isDealerMicroSite: state => state.isDealerMicroSite,
  dealerName: state => state.dealerName
};
